import React from 'react'
import Portal from '../../../../component/portal'
import HmNew from '../hmNew'
import HmHot from '../hmHot'
import HmList from '../hmList'
import { AppContext } from '../../../../config/context'
import { i18n } from '../../../../common/util'

class Homemade extends React.Component {
    constructor() {
        super(...arguments)
    }

    render() {
        const { lang } = this.context.user
        return <div>
            <h2 className="sec-page-title new"><i className="icon new"></i>新品上架</h2>
            <HmNew></HmNew>
            <h2 className="sec-page-title hot"><i className="icon hot"></i>{i18n('热游推荐', lang)}</h2>
            <HmHot></HmHot>
            <h2 className="sec-page-title"><i className="icon cate"></i>{i18n('国产游戏分类', lang)}</h2>
            <HmList></HmList>
        </div>
    }
}

Homemade.contextType = AppContext
export default Portal(Homemade, 'homemade-page-container')